"use client"

import { ListChecks } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ListChecksIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ListChecksIcon = component(Icon)({ as: ListChecks })
